import {createContext, useContext} from 'react';

const ContentTreeContext = createContext(null);

export const useContentTreeContext = () => useContext(ContentTreeContext);

export default ContentTreeContext;
